// Parse HTTP date string to timestamp
function parseHttpDate(dateString) {
    if (!dateString || typeof dateString !== "string") return null;
  
    try {
      // Handle format: "Thu, 09 Oct 2025 04:37:16 GMT"
      return new Date(dateString).getTime();
    } catch (error) {
      console.warn("Failed to parse HTTP date:", dateString, error);
      return null;
    }
  }

export { parseHttpDate };